import { renderRoot } from 'quartz-core/client';
import history from './utils/history';

// I18n Configuration
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';

// Rhumb
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4';

// Configure the router
import { Router } from 'quartz-routing/react-router';
import Routes from './Routes';
import { getPageLangLocale } from 'unsubscribe-ui/utils/language';
import { Suspense } from 'react';
// Logging
import Raven from 'raven-js';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default class App {
  // Kicks off the app. This is intentionally not in the constructor.
  start() {
    const langLocale = getPageLangLocale(window.location.pathname);
    const I18nPublicProvider = createPublicI18nProvider({
      manuallySetLocale: true
    });
    I18nPublicProvider.setLocale({
      locale: langLocale,
      langEnabled: true
    });
    I18nPublicProvider.register(lang).then(() => {
      this.startRouter();
    }).catch(err => {
      Raven.captureException(new Error('Language initialization Failure'), {
        extra: err
      });
    });
  }
  startRouter() {
    renderRoot( /*#__PURE__*/_jsx(RhumbProvider, {
      history: historyAdapter(history)
      // @ts-ignore TODO: Figure this out later - typing of imported JSON
      ,
      config: rhumbConfig,
      children: /*#__PURE__*/_jsx(Suspense, {
        fallback: /*#__PURE__*/_jsx(_Fragment, {}),
        children: /*#__PURE__*/_jsx(Router, {
          history: history,
          children: /*#__PURE__*/_jsx(Routes, {})
        })
      })
    }));
  }
}